import React from "react";
import { Flex, Divider, Heading } from "@aws-amplify/ui-react";
import { useSymptomsQuery } from "./api/useSymptomsQuery";
import SymptomsCard from "./SymptomsCard";
import SymptomsTable from "./SymptomsTable";
import { useUserQuery } from "../common/useUserQuery";

export default function SymptomsPage() {
  const { data: userQueryData } = useUserQuery();

  const {
    error,
    data: symptomResults,
    isFetching,
  } = useSymptomsQuery(userQueryData?.patientUserId);

  if (isFetching) return "Loading...";

  if (error) return "An error happened, try refreshing the browser.";

  return (
    <>
      <Flex gap="18px" direction="column">
        {symptomResults?.length > 0 &&
          symptomResults?.map((symptom, index) => {
            if (symptom.active === 0) return false;
            return <SymptomsCard key={index} data={symptom}></SymptomsCard>;
          })}
      </Flex>
      <Divider
        width="unset"
        height="1px"
        shrink="0"
        alignSelf="stretch"
        size="small"
        orientation="horizontal"
        style={{ marginTop: "0px" }}
      ></Divider>
      <Heading level="6" children="History Symptoms"></Heading>
      <SymptomsTable
        data={symptomResults?.filter((item) => item.active === 0)}
      ></SymptomsTable>
    </>
  );
}
